import { render, staticRenderFns } from "./out_of_stock.vue?vue&type=template&id=51bd6a54&"
import script from "./out_of_stock.vue?vue&type=script&lang=js&"
export * from "./out_of_stock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports